/**
 * Converts a local Date object to an ISO string in UTC on the same day.
 *
 * @param date - The local Date object (from user input, e.g. DatePicker)
 * @param isEndDate - If true, sets time to 23:59:59.999 UTC. Otherwise 00:00:00.000 UTC.
 */
export const formatLocalDateToUTCISO = (date: Date | null, isEndDate = false): string => {
  if (!date) return '';

  const local = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    isEndDate ? 23 : 0,
    isEndDate ? 59 : 0,
    isEndDate ? 59 : 0,
    isEndDate ? 999 : 0,
  );

  return local.toISOString();
};

/**
 * Formats an ISO date string as "Mar 15, 2026, 8:00 AM".
 */
export const formatEventDateTime = (isoString: string): string =>
  new Date(isoString).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
